// src/pages/IntakeSummaryViewPage.js
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Alert, Button, Card, Col, Row, Spinner } from "react-bootstrap";
import api from "../api";
import ClientContactLine from "../components/ClientContactLine";

function displayOrDash(v) {
  const s = v == null ? "" : String(v);
  return s.trim() ? s : "—";
}

export default function IntakeSummaryViewPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [intakeSummary, setIntakeSummary] = useState("");

  useEffect(() => {
    let mounted = true;

    async function load() {
      setLoading(true);
      setError("");

      try {
        const res = await api.get(`/clients/${id}`);
        if (!mounted) return;

        const c = res.data || {};
        setIntakeSummary(c.intake_summary ?? "");
      } catch (e) {
        if (!mounted) return;
        setError(
          e?.response?.data?.message ||
            e?.message ||
            "Failed to load client intake summary."
        );
      } finally {
        if (mounted) setLoading(false);
      }
    }

    load();
    return () => {
      mounted = false;
    };
  }, [id]);

  if (loading) {
    return (
      <div className="p-3">
        <Spinner animation="border" size="sm" className="me-2" />
        Loading intake summary...
      </div>
    );
  }

  return (
    <div className="p-3">
      <Row className="mb-3">
        <Col>
          <h3 className="mb-0">Intake Summary</h3>
          <ClientContactLine clientId={id} />
          <div className="text-muted">Client ID: {id}</div>
        </Col>

        <Col className="d-flex justify-content-end align-items-start gap-2">
          <Button variant="outline-secondary" type="button" onClick={() => navigate("/clients")}>
            Back to Clients
          </Button>

          <Button
            variant="primary"
            type="button"
            onClick={() => navigate(`/clients/${id}/intake-summary`)}
          >
            Edit Intake Summary
          </Button>
        </Col>
      </Row>

      {error ? <Alert variant="danger">{error}</Alert> : null}

      <Card>
        <Card.Body>
          <div className="text-muted mb-2" style={{ fontSize: "0.9rem" }}>
            Intake Summary
          </div>

          <div
            style={{
              whiteSpace: "pre-wrap",
              border: "1px solid rgba(0,0,0,0.125)",
              borderRadius: 6,
              padding: 12,
              minHeight: 220,
              background: "rgba(0,0,0,0.02)",
            }}
          >
            {displayOrDash(intakeSummary)}
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}
